import Illustration from '@app/illu/Image/EmptySessions.svg';
import { EmptyScreen } from 'components/PageLayout/EmptyScreen';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';

export const EmptyList = () => {
  const { t } = useTranslation();
  return (
    <EmptyScreen
      illustration={Illustration}
      title={t('sessions.empty.title')}
      text={t('sessions.empty.text')}
      button={
        <Button
          to="/sessions/create"
          text={t('sessions.empty.button')}
          withNextArrow
        />
      }
    />
  );
};
